export default {
  name: 'gmk-merlin',
  override: {
    KC_ESC: 'accent',
    KC_ENT: 'accent'
  }
};
